var wx = require('weixin-js-sdk');
import Fetch from '@/api';
let $ = window.$;
var wechat = {
  config: {},
  shareData: {
    link: location.href,
    imgUrl: '',
    title: $('title').text(),
    content: '',
    desc: ''
  },
  _getShareConfig: function (callback) {
    Fetch.getWxConfig().then((data) => {
      wechat.config = data;
      var defaultJsApiList = [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareQZone',
        'onMenuShareWeibo',
        'hideOptionMenu',
        'showOptionMenu',
        'chooseImage',
        'uploadImage',
        'previewImage',
        'getLocation',
        'openLocation',
        'getLocalImgData',
        'closeWindow',
        'updateAppMessageShareData',
        'downloadVoice',
        'playVoice',
        'stopVoice'
        // 'updateTimelineShareData'
      ];
      wechat.setConfig(defaultJsApiList);
      wechat.setCommonBehavior();
      wx.error(function (res) {
        console.log('wx_fail:');
        window.console.warn(res);
      });
      callback && callback.constructor == Function && callback();
    });
  },
  refreshWechatCookie: function refreshWechatCookie(errorPage) {
    let redirectUrl = encodeURIComponent(location.href);
    if (errorPage) {
      redirectUrl = encodeURIComponent(errorPage);
    }
    window.location.href = window.util.getZyydApi() + '/medicsale/wechatLogin' + '?redirectUrl=' + redirectUrl;
  },
  setShareData: function setShareData(shareObj) {
    this.shareData = $.extend(this.shareData, shareObj);
  },
  initConfig: function initConfig(callback) {
    this._getJSSDKConfig(callback);
  },
  setConfig: function setConfig(apiList) {
    var self = this;
    wx &&
      wx.config({
        debug: false,
        appId: self.config.appId,
        timestamp: self.config.timestamp,
        nonceStr: self.config.nonceStr,
        signature: self.config.signature,
        jsApiList: apiList
      });
  },
  _getJSSDKConfig: function (callback) {
    this._getShareConfig(callback);
  },
  closeWindow: function closeWindow() {
    wx &&
      wx.ready(function () {
        setTimeout(() => {
          wx.closeWindow();
        }, 300);
      });
  },
  hideOptionMenu: function hideOptionMenu() {
    wx &&
      wx.ready(function () {
        wx.hideOptionMenu();
      });
  },
  showOptionMenu: function showOptionMenu() {
    wx &&
      wx.ready(function () {
        wx.showOptionMenu();
      });
  },
  setCommonBehavior: function setCommonBehavior() {
    this.shareTimeline(this.shareData);
    this.shareAppMessage(this.shareData);
    this.shareQQ(this.shareData);
    this.shareQZone(this.shareData);
    this.shareWeibo(this.shareData);
  },
  shareTimeline: function shareTimeline(params) {
    var self = this;
    wx &&
      wx.ready(function () {
        wx.onMenuShareTimeline({
          title: params.title,
          desc: params.desc,
          link: params.link,
          imgUrl: params.imgUrl,
          success: self.successFn,
          cancel: self.cancelFn
        });
      });
  },
  shareAppMessage: function shareAppMessage(params) {
    var self = this;
    wx &&
      wx.ready(function () {
        wx.onMenuShareAppMessage({
          title: params.title,
          desc: params.desc,
          link: params.link,
          imgUrl: params.imgUrl,
          success: self.successFn,
          cancel: self.cancelFn
        });
      });
  },
  shareQQ: function shareQQ(params) {
    var self = this;
    wx &&
      wx.ready(function () {
        wx.onMenuShareQQ({
          title: params.title,
          desc: params.desc,
          link: params.link,
          imgUrl: params.imgUrl,
          success: self.successFn,
          cancel: self.cancelFn
        });
      });
  },
  shareQZone: function shareQZone(params) {
    var self = this;
    wx &&
      wx.ready(function () {
        wx.onMenuShareQZone({
          title: params.title,
          desc: params.desc,
          link: params.link,
          imgUrl: params.imgUrl,
          success: self.successFn,
          cancel: self.cancelFn
        });
      });
  },
  shareWeibo: function shareWeibo(params) {
    var self = this;
    wx &&
      wx.ready(function () {
        wx.onMenuShareQZone({
          title: params.title,
          desc: params.desc,
          link: params.link,
          imgUrl: params.imgUrl,
          success: self.successFn,
          cancel: self.cancelFn
        });
      });
  },
  successFn: function successFn() {
    console.log('分享成功');
  },
  cancelFn: function cancelFn() {
    $.toast('分享已取消');
  },
  chooseImage: function chooseImage() {
    var self = this;
    var def = $.Deferred();
    wx &&
      wx.ready(function () {
        wx.chooseImage({
          success: function success(res) {
            self.uploadImage(res.localIds).then(function (resp) {
              def.resolve(resp);
            });
          }
        });
      });
    return def;
  },
  getImgBase64: function chooseImage(count) {
    var self = this;
    var def = $.Deferred();
    wx &&
      wx.ready(function () {
        wx.chooseImage({
          count,
          success: function success(res) {
            def.resolve(res.localIds);
          }
        });
      });
    return def;
  },
  getLocalImgData: function getLocalImgData(localId) {
    var self = this;
    var def = $.Deferred();
    wx &&
      wx.ready(function () {
        wx.getLocalImgData({
          localId,
          success: function success({ localData }) {
            if (!localData.indexOf('data:image') == 0) {
              localData = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
            }
            def.resolve(localData);
          }
        });
      });
    return def;
  },
  getLocation: function getLocation() {
    var self = this;
    var def = $.Deferred();
    wx &&
      wx.ready(function () {
        wx.getLocation({
          type: 'wgs84',
          success(res) {
            def.resolve(res);
          },
          fail(err) {
            console.log('Fail:', err);
            def.reject(err);
          }
        });
        // wx.chooseImage({
        //   success: function success(res) {
        //     self.uploadImage(res.localIds).then(function(resp) {
        //       def.resolve(resp);
        //     });
        //   }
        // });
      });
    return def;
  },
  openLocation: function openLocation(params) {
    var self = this;
    var def = $.Deferred();
    wx &&
      wx.ready(function () {
        wx.openLocation({
          latitude: params.latitude, // 纬度，浮点数，范围为90 ~ -90
          longitude: params.longitude, // 经度，浮点数，范围为180 ~ -180。
          name: params.name, // 位置名
          address: params.address, // 地址详情说明
          scale: params.scale, // 地图缩放级别,整型值,范围从1~28。默认为最大
          infoUrl: params.infoUrl,
          success(res) {
            def.resolve(res);
          }
        });
      });
    return def;
  },
  uploadImage: function uploadImage(localIds) {
    var serverIds = [];
    var def = $.Deferred();
    var upload = function f(localIds) {
      var localId = localIds.pop();
      wx.uploadImage({
        localId: localId,
        success: function success(res) {
          serverIds.push(res.serverId);
          if (localIds.length > 0) {
            setTimeout(f(localIds), 100);
          } else {
            def.resolve(serverIds);
          }
        }
      });
    };
    upload(localIds);
    return def;
  },

  previewImage: function previewImage(url, urls) {
    wx &&
      wx.ready(function () {
        wx.previewImage({
          current: url,
          urls: urls
        });
      });
  },
  isUserLogin: function isUserLogin() {
    var isUserLogin = window.util.getCookie('zyyd_login');
    return !!isUserLogin;
  },
  wechatAuth: function wechatAuth(cb, errorPage) {
    this.initConfig();
    if (!this.isUserLogin() || errorPage) {
      this.refreshToken(errorPage);
    } else {
      cb && cb.constructor == Function && cb();
    }
  },
  refreshToken: function refreshToken(errorPage) {
    this.refreshWechatCookie(errorPage);
  },
  updateAppMessageShareData: function updateAppMessageShareData(options) {
    const self = this;
    wx &&
      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: options.title,
          desc: options.desc,
          link: options.link,
          imgUrl: options.imgUrl,
          success: options.success || self.successFn
        });
      });
  },
  updateTimelineShareData: function updateTimelineShareData(options) {
    const self = this;
    wx &&
      wx.ready(function () {
        wx.updateTimelineShareData({
          title: options.title,
          desc: options.desc,
          link: options.link,
          imgUrl: options.imgUrl,
          success: options.success || self.successFn
        });
      });
  },
  downloadVoice: function downloadVoice(options) {
    var def = $.Deferred();
    wx &&
      wx.ready(function () {
        wx.downloadVoice({
          serverId: options.serverId,
          isShowProgressTips: 1,
          success(res) {
            def.resolve(res);
          }
        });
      });
    return def;
  },
  playVoice: function playVoice(options) {
    var def = $.Deferred();
    wx &&
      wx.ready(function () {
        wx.playVoice({
          localId: options.localId
        });
        wx.onVoicePlayEnd({
          success: function (res) {
            def.resolve(res); // 返回音频的本地ID
          },
          fail: function (res) {
            def.resolve('fail');
          }
        });
      });
    return def;
  },
  stopVoice: function stopVoice(options) {
    wx &&
      wx.ready(function () {
        wx.stopVoice({
          localId: options.localId
        });
      });
  }
  // reAuth: function reAuth() {
  //   this.wechatAuth();
  //   window.util.refreshReload();
  // }
};
window.wx = wechat;

export default wechat;
